// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2Ct5U","label":"Section_label__1aBPx","contentWrap":"Section_contentWrap__1k5Dk","footer":"Section_footer__ppNoP","footerInner":"Section_footerInner__3VXIm"};